import React, { useState, useEffect } from "react";
import "./App.css";
import "./MapButtons.css";
import WindowDimensions from "./WindowDimensions";
import data from "./data/Pins.json";

const MapButtons = ({ swapPins, pinHighlightIndex, highlightMapImage, unhighlightMapImage, mapPageCallback, closePopup }) => {
  const [highlightId, setHighlightId] = useState(pinHighlightIndex);
  const { width } = WindowDimensions();
  var isMobile = false;

  if (width <= 768) {
    isMobile = true;
  } else {
    isMobile = false;
  }

  function handleClick(event, id) {
    // mapPageCallback(event);
    closePopup();
    swapPins(event);
  }

  function highlightIcon(event, id) {
    highlightMapImage(event);
    setHighlightId(event.currentTarget.name);
  }

  function unhighlightIcon(event) {
    unhighlightMapImage(event);
    setHighlightId(-1);
  }

  return (
    <div style={{ margin: "5% 0" }}>
      {!isMobile ? (
        <div style={{ display: "flex", flex: 1, height: "100%", flexDirection: "column", justifyContent: "space-evenly" }}>
          {data["themes"].map((theme, i) => {
            return (
              <button
                id={theme.theme + "(" + data["journeyCategory"] + ")"}
                key={i}
                name={theme.theme}
                style={{
                  width: "100%",
                  height: "20%",
                  fontSize: "12pt",
                  marginTop: "5px",
                  marginBottom: "5px",
                  borderRadius: "5px",
                  backgroundColor: theme.theme === highlightId || theme.theme === pinHighlightIndex ? `#${theme.colour}` : "grey",
                }}
                onClick={(event) => handleClick(event, i)}
                onMouseOver={(event) => highlightIcon(event, i)}
                onMouseLeave={(event) => unhighlightIcon(event)}
                className={
                  theme.theme === pinHighlightIndex || theme.theme === highlightId
                    ? "MapButtons-scope-button MapButtons-scope-button-active MapButtons-scope-button-text"
                    : "MapButtons-scope-button MapButtons-scope-button-text"
                }
              >
                {theme.theme}
              </button>
            );
          })}
        </div>
      ) : (
        <div
          style={{ display: "flex", flex: 1, flexDirection: "row", flexWrap: "wrap", width: "78vw", height: "100px", justifyContent: "space-evenly", alignContent: "space-evenly" }}
        >
          {data["themes"].map((theme, i) => {
            return (
              <button
                id={theme.theme + "(" + data["journeyCategory"] + ")"}
                key={i}
                name={theme.theme}
                style={{ width: "100%", height: "100%", margin: "5px", fontSize: "12pt", borderRadius: "5px" }}
                onClick={(event) => handleClick(event, i)}
                onMouseOver={(event) => highlightIcon(event, i)}
                onMouseLeave={(event) => unhighlightIcon(event)}
                className={
                  theme.theme === pinHighlightIndex
                    ? "MapButtons-scope-button MapButtons-scope-button-active MapButtons-scope-button-text"
                    : "MapButtons-scope-button MapButtons-scope-button-text"
                }
              >
                {theme.theme}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MapButtons;
